export const candidate = {
    labels: {
        full_name: "Nome Completo",
        social_name: "Nome Social",
        gender: "Gênero",
        about: "Sobre e Hobbies",
    },
    placeholders: {
        full_name: "Insira seu nome completo",
        social_name: "Insira seu nome social",
        about: "Fale um pouco sobre você e seus hobbies.",
    },
    texts: {
    },
};
